import PageHead from './Component';

export default PageHead;